<template>
  <bm-control
    v-bind="$attrs"
    :read-only-value="value ? trueLabelOrDefault : falseLabelOrDefault"
  >
    <template #default="{ dataQa }">
      <!-- v-switch does not support focus or mouse over events -->
      <div @mouseover="setFocused(true)" @mouseleave="setFocused(false)">
        <v-switch
          :input-value="value"
          color="switch"
          v-bind="$attrs"
          :label="trueLabelOrDefault"
          :data-qa="dataQa"
          @change="$emit('input', $event)"
          @focus="bubbleEvent($event)"
          @blur="bubbleEvent($event)"
          @click="bubbleEvent($event)"
        >
          <template #prepend>
            <span
              class="v-label bm-switch-text"
              @click="$emit('input', !value)"
            >
              {{ falseLabelOrDefault }}
            </span>
          </template>
        </v-switch>
      </div>
      <div
        v-if="errorMessages.length > 0"
        class="v-messages theme--light error--text"
      >
        <div class="v-messages__wrapper">
          <div class="v-messages__message">
            {{ errorMessages[0] }}
          </div>
        </div>
      </div>
    </template>
  </bm-control>
</template>

<script lang="ts">
import BmControl from "@/components/controls/input/BmControl.vue";
import BmInputField from "@/components/controls/input/mixins/BmInputField";
import type { PropType } from "vue";
import { defineComponent } from "vue";
/**
 * Closely based on v-switch with the main difference being we have a label before the toggle as well as the standard
 * suffixed label.
 *
 * We use the prepend slot for the left label and the existing main label as the appended text.
 */
export default defineComponent({
  name: "BmSwitch",
  components: { BmControl },
  mixins: [BmInputField],
  inheritAttrs: false,
  props: {
    value: {
      type: Boolean,
      required: false,
    },
    trueLabel: {
      type: String,
      default: "",
    },
    falseLabel: {
      type: String,
      default: "",
    },
    errorMessages: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  computed: {
    trueLabelOrDefault(): any {
      return this.trueLabel || this.$m.switch_true_label;
    },
    falseLabelOrDefault(): any {
      return this.falseLabel || this.$m.switch_false_label;
    },
  },
});
</script>

<style scoped lang="sass">
@import "src/sass/typography"

// Move margin to padding on the text for proper event handling
.bm-switch-text
  padding-right: 9px

:deep(.v-input__prepend-outer)
  margin-right: 0

.v-input--switch
  cursor: pointer
  user-select: none
  max-width: fit-content

.bm-switch-text, .v-input--switch :deep(.v-label)
  @include bm-body

.v-input--is-disabled :deep(.bm-switch-text)
  color: rgba(#000000, .38)!important

.bm-field label
  margin-bottom: 10px

/** The prepended slot sits too high and need to be pushed down **/
span
  margin-top: 3px

/** We have taken over rendering the error message so hide the one in the original control to not create extra space **/
.v-input--switch :deep(.v-messages)
  display: none

/** Push out to the right and move up a smidge **/
.v-icon
  margin-left: 10px
  position: relative
  top: -3px
</style>
